import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
var _excluded = ["rtl", "mostPopularText", "setValue", "setIsOpened", "fieldValue"],
  _excluded2 = ["asAMetroChild", "firstInGroup"],
  _excluded3 = ["asAMetroChild", "firstInGroup"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import './LocationSelect.css';
import React, { useState, useEffect, useRef } from 'react';
import { ReactComponent as MyLocationIcon } from '../../../resources/icons/my-location.svg';
import { ReactComponent as IconArrowLeft } from '../../../resources/icons/IconArrowLeft.svg';
import { ReactComponent as IconArrowRight } from '../../../resources/icons/IconArrowRight.svg';
import { ReactComponent as IconPlane } from '../../../resources/icons/iconPlane.svg';
import { ReactComponent as IconEnterLeft } from '../../../resources/icons/IconArrowEnterLeft.svg';
import { ReactComponent as IconEnterRight } from '../../../resources/icons/IconArrowEnterRight.svg';
/* import { canUseDOM } from '../../../utils'; */

var Destinations = function Destinations(_ref) {
  var buttonText = _ref.buttonText,
    optionsNumber = _ref.optionsNumber,
    dropDownOpened = _ref.dropDownOpened,
    children = _ref.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showMore = _useState2[0],
    setShowMore = _useState2[1];
  useEffect(function () {
    setShowMore(optionsNumber > 20);
  }, [optionsNumber, dropDownOpened]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(showMore ? 'location-select__options-wrapper--shortened-view' : '')
  }, children), showMore && /*#__PURE__*/React.createElement("button", {
    className: "location-select__more-btn",
    onClick: function onClick() {
      setShowMore(false);
    }
  }, buttonText));
};
var AirprtItem = function AirprtItem(props) {
  var rtl = props.rtl,
    mostPopularText = props.mostPopularText,
    setValue = props.setValue,
    setIsOpened = props.setIsOpened,
    fieldValue = props.fieldValue,
    locationProps = _objectWithoutProperties(props, _excluded);
  var firstInGroup = locationProps.firstInGroup,
    isPopularHeader = locationProps.isPopularHeader,
    value = locationProps.value,
    Name = locationProps.Name,
    popularItem = locationProps.popularItem,
    groupLabel = locationProps.groupLabel,
    asAMetroChild = locationProps.asAMetroChild,
    city = locationProps.city,
    country = locationProps.country,
    airportCode = locationProps.airportCode;
  return /*#__PURE__*/React.createElement("div", {
    className: "\n        location-select__option\n        ".concat(firstInGroup || isPopularHeader ? 'location-select__option--first-in-group' : '', "\n        ").concat(fieldValue.value === value && fieldValue.Name === Name ? 'location-select__option--is-selected' : '', "\n        ").concat(popularItem ? 'location-select__option--popular' : '', "\n      "),
    onClick: function onClick() {
      setValue(locationProps);
      setIsOpened(false);
    }
  }, firstInGroup && /*#__PURE__*/React.createElement("div", {
    className: "location-select__group-heading"
  }, groupLabel), isPopularHeader && /*#__PURE__*/React.createElement("div", {
    className: "location-select__group-heading"
  }, mostPopularText), /*#__PURE__*/React.createElement("div", {
    className: "location-select__option-names ".concat(asAMetroChild ? 'location-select__option-names--metro-child' : '')
  }, /*#__PURE__*/React.createElement("h6", {
    className: "is-ellipsed"
  }, city, ", ", country), /*#__PURE__*/React.createElement("p", {
    className: "is-ellipsed"
  }, rtl ? /*#__PURE__*/React.createElement(IconEnterLeft, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(IconEnterRight, {
    className: "icon"
  }), " ", Name)), /*#__PURE__*/React.createElement("span", {
    className: "location-select__option-code"
  }, airportCode));
};
var LocationSelect = function LocationSelect(_ref2) {
  var rtl = _ref2.rtl,
    isMobile = _ref2.isMobile,
    isOpened = _ref2.isOpened,
    setIsOpened = _ref2.setIsOpened,
    departureField = _ref2.departureField,
    headerText = _ref2.headerText,
    fromValue = _ref2.fromValue,
    toValue = _ref2.toValue,
    fieldValue = _ref2.fieldValue,
    locationsList = _ref2.locationsList,
    inputValue = _ref2.inputValue,
    setInputValue = _ref2.setInputValue,
    setMyLocation = _ref2.setMyLocation,
    clearField = _ref2.clearField,
    setValue = _ref2.setValue,
    focusedOnce = _ref2.focusedOnce,
    setFocusedOnce = _ref2.setFocusedOnce,
    textClear = _ref2.textClear,
    fromText = _ref2.fromText,
    toText = _ref2.toText,
    labelText = _ref2.labelText,
    labelHelpText = _ref2.labelHelpText,
    useCurrentLocationText = _ref2.useCurrentLocationText,
    loadNMoreDestinationsText = _ref2.loadNMoreDestinationsText,
    mostPopularText = _ref2.mostPopularText,
    mobilePlaceholder = _ref2.mobilePlaceholder,
    error = _ref2.error,
    errorEmptyText = _ref2.errorEmptyText,
    errorInvalidText = _ref2.errorInvalidText,
    invalidFilter = _ref2.invalidFilter,
    setInvalidFilter = _ref2.setInvalidFilter;
  var inputTextRef = useRef(false);
  var inputDeskTextRef = useRef(false);
  var locationsListRef = useRef(false);
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    startedUtocomplete = _useState4[0],
    setStartedAutocomplete = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    deskFieldHighlighted = _useState6[0],
    setDeskFieldHighlighted = _useState6[1];
  var deskFieldClickedRef = useRef(false);
  var optionsNumber = locationsList.length;
  var loadMoreButtonText = loadNMoreDestinationsText.replace('%n%', String(optionsNumber - 20));
  var componentPrefix = departureField ? 'departure' : 'destination';
  useEffect(function () {
    if (isOpened) {
      if (isMobile) {
        if (inputTextRef.current) inputTextRef.current.focus();
      } else {
        deskFieldClickedRef.current = true;
        if (inputDeskTextRef.current) inputDeskTextRef.current.focus();
      }
    }
  }, [isOpened, isMobile]);
  useEffect(function () {
    if (!isOpened) {
      locationsListRef.current.scrollTo(0, 0);
      setStartedAutocomplete(false);
    }
  }, [isOpened]);
  useEffect(function () {
    if (inputValue && !startedUtocomplete) {
      setStartedAutocomplete(true);
    }
  }, [inputValue]);
  var renderFiltered = function renderFiltered() {
    var currentLabel = '';

    /* Filtering method */
    var filterList = function filterList(locationItem) {
      if (locationItem.popularItem) {
        return null;
      }
      if (locationItem.city.toLowerCase().startsWith(inputValue.toLowerCase())) {
        var asAMetroChild = locationItem.asAMetroChild,
          firstInGroup = locationItem.firstInGroup,
          formatted = _objectWithoutProperties(locationItem, _excluded2);
        return {
          category: 'starters',
          value: formatted
        };
      }
      if (locationItem.city.toLowerCase().includes(inputValue.toLowerCase()) || locationItem.country.toLowerCase().includes(inputValue.toLowerCase())) {
        var _asAMetroChild = locationItem.asAMetroChild,
          _firstInGroup = locationItem.firstInGroup,
          _formatted = _objectWithoutProperties(locationItem, _excluded3);
        if (locationItem.groupLabel !== currentLabel) {
          currentLabel = locationItem.groupLabel;
          _formatted.firstInGroup = true;
        }
        return {
          category: 'others',
          value: _formatted
        };
      }
      return null;
    };
    var result = locationsList.reduce(function (acc, item) {
      var filtered = filterList(item);
      if (filtered) {
        acc[filtered.category].push(filtered.value);
      }
      return acc;
    }, {
      starters: [],
      others: []
    });
    var final = [].concat(_toConsumableArray(result.starters), _toConsumableArray(result.others));
    setInvalidFilter(!(!!final.length && inputValue));
    return final.map(function (item) {
      return /*#__PURE__*/React.createElement(AirprtItem, _extends({
        key: "results-".concat(componentPrefix, "-").concat(item.value, "-").concat(item.Name),
        mostPopularText: mostPopularText,
        setValue: setValue,
        setIsOpened: setIsOpened,
        fieldValue: fieldValue
      }, item));
    });
  };
  var deskFieldFocusHandler = function deskFieldFocusHandler() {
    setIsOpened(true);
    if (!focusedOnce) {
      setFocusedOnce();
    }
    if (!deskFieldClickedRef.current) {
      setDeskFieldHighlighted(true);
    }
  };
  var deskFieldDownkHandler = function deskFieldDownkHandler() {
    deskFieldClickedRef.current = true;
  };
  var deskFieldBlurHandler = function deskFieldBlurHandler() {
    deskFieldClickedRef.current = false;
    setDeskFieldHighlighted(false);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement(React.Fragment, null, optionsNumber ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "d-md-none",
    tabIndex: 0,
    onClick: function onClick() {
      setIsOpened(true);
      if (!focusedOnce) setFocusedOnce();
    }
  }, fieldValue.value ? /*#__PURE__*/React.createElement("div", {
    className: "city-selector__mobile-value"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "city-selector__value-head is-ellipsed"
  }, fieldValue.city), /*#__PURE__*/React.createElement("p", {
    className: "city-selector__value-subhead is-ellipsed"
  }, fieldValue.Name, " ", fieldValue.airportCode)) : /*#__PURE__*/React.createElement("span", {
    className: "city-selector__mobile-label"
  }, labelText)), /*#__PURE__*/React.createElement("div", {
    className: "\n              city-selector__desc d-none d-md-block\n              ".concat(focusedOnce || fieldValue.value ? '' : 'city-selector__desc--untouched', "\n            ")
  }, /*#__PURE__*/React.createElement("span", {
    className: "city-selector__desc-label"
  }, labelText), focusedOnce || fieldValue.value ? null : /*#__PURE__*/React.createElement("span", {
    className: "city-selector__desc-help-label is-ellipsed"
  }, labelHelpText), fieldValue.value && /*#__PURE__*/React.createElement("div", {
    className: "city-selector__desc-value"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "city-selector__value-head is-ellipsed"
  }, fieldValue.city), /*#__PURE__*/React.createElement("p", {
    className: "city-selector__value-subhead is-ellipsed"
  }, fieldValue.Name, " ", fieldValue.airportCode)), /*#__PURE__*/React.createElement("input", {
    value: inputValue,
    onChange: function onChange(e) {
      setInputValue(e.target.value);
    },
    onFocus: deskFieldFocusHandler,
    onMouseDown: deskFieldDownkHandler,
    onBlur: deskFieldBlurHandler,
    type: "text",
    className: "".concat(deskFieldHighlighted ? 'field--focused' : '', " city-selector__input"),
    ref: inputDeskTextRef
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "d-md-none"
  }, /*#__PURE__*/React.createElement("span", {
    className: "city-selector__mobile-label"
  }, labelText)), /*#__PURE__*/React.createElement("div", {
    className: "city-selector__desc d-none d-md-block city-selector__desc--untouched"
  }, /*#__PURE__*/React.createElement("span", {
    className: "city-selector__desc-label"
  }, labelText), /*#__PURE__*/React.createElement("span", {
    className: "city-selector__desc-help-label is-ellipsed"
  }, labelHelpText))), error && /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper__dest-error is-ellipsed"
  }, inputValue ? errorInvalidText : errorEmptyText), /*#__PURE__*/React.createElement("div", {
    className: "\n          location-select\n          ".concat(isOpened && optionsNumber ? '' : 'location-select--hidden', "\n          ").concat(invalidFilter ? 'location-select--filter-invalid' : '', "\n          ").concat(!!inputValue ? 'location-select--filter-processed' : '', "\n        ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-md-none dropdown-header"
  }, /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__back",
    onClick: function onClick() {
      setIsOpened(false);
    }
  }, rtl ? /*#__PURE__*/React.createElement(IconArrowRight, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(IconArrowLeft, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "dropdown-header__text"
  }, headerText), !departureField && clearField && /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__clear",
    onClick: function onClick() {
      clearField();
    }
  }, textClear)), /*#__PURE__*/React.createElement("div", {
    className: "d-md-none dropdown-state-area"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-state-area__cell"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-state-area__label ".concat(fromValue ? 'dropdown-state-area__label--selected' : '')
  }, fromText), fromValue ? /*#__PURE__*/React.createElement("div", {
    className: "dropdown-state-area__city"
  }, fromValue) : null)), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-state-area__plane-icon"
  }, /*#__PURE__*/React.createElement(IconPlane, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-state-area__cell"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-state-area__label ".concat(toValue ? 'dropdown-state-area__label--selected' : '')
  }, toText), toValue ? /*#__PURE__*/React.createElement("div", {
    className: "dropdown-state-area__city"
  }, toValue) : null))), /*#__PURE__*/React.createElement("div", {
    className: "d-md-none location-select__autocomplete-wrapper"
  }, /*#__PURE__*/React.createElement("input", {
    ref: inputTextRef,
    type: "text",
    className: "location-select__autocomplete-field",
    value: inputValue,
    onChange: function onChange(e) {
      setInputValue(e.target.value);
    },
    placeholder: mobilePlaceholder
  })), departureField && setMyLocation && /*#__PURE__*/React.createElement("button", {
    className: "location-select__locator-btn",
    onClick: function onClick() {
      setMyLocation();
    }
  }, useCurrentLocationText, " ", /*#__PURE__*/React.createElement(MyLocationIcon, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "\n            location-select__body\n            ".concat(startedUtocomplete ? 'location-select__body--disabled-loadmore location-select__body--disabled-populars' : '', "\n          "),
    ref: locationsListRef
  }, /*#__PURE__*/React.createElement(Destinations, {
    buttonText: loadMoreButtonText,
    optionsNumber: optionsNumber,
    dropDownOpened: isOpened
  }, !!inputValue ? renderFiltered() : locationsList.map(function (location) {
    var isPopularPrefix = location.popularItem ? 'popular-' : '';
    return /*#__PURE__*/React.createElement(AirprtItem, _extends({
      key: "".concat(isPopularPrefix).concat(componentPrefix, "-").concat(location.value, "-").concat(location.Name),
      mostPopularText: mostPopularText,
      setValue: setValue,
      setIsOpened: setIsOpened,
      fieldValue: fieldValue
    }, location));
  }))))));
};
var commonStyles = "c1r5g8l3";
var ltrStyles = "l1mw5ww3";
var rtlStyles = "r1o4fb68";
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
export default LocationSelect;